import {Component, OnDestroy, OnInit} from "@angular/core";
import {SubscriptionService} from "../../../subscription/subscription.service";
import {ActivatedRoute, Router} from "@angular/router";
import {BuyService} from "../../../buy/buy.service";
import {Model} from "../../../app.model";
import {HttpClient} from "@angular/common/http";
import {CompanyService} from "../../../company/company.service";
import {WorkflowEndcustomerService} from "../workflow-endcustomer.service";
import {WorkflowEndcustomerChangeSlaComponent} from "../workflow-endcustomer-change-sla.component";

@Component({
    selector: 'app-workflow-endcustomer-one-upgrade-sla',
    templateUrl: './workflow-endcustomer-one-upgrade-sla.component.html',
    standalone: false
})
export class WorkflowEndcustomerOneUpgradeSlaComponent extends WorkflowEndcustomerChangeSlaComponent implements OnInit, OnDestroy {
  constructor(protected route: ActivatedRoute,
              protected router: Router,
              protected subscriptionService: SubscriptionService,
              protected buyService: BuyService,
              protected m: Model,
              protected http: HttpClient,
              protected workflowEndcustomerService: WorkflowEndcustomerService,
              protected companyService: CompanyService) {
    super(route, router, subscriptionService, buyService, m, http, workflowEndcustomerService, companyService);
  }

  async ngOnInit() {
    super.ngOnInit();
    await this.initWorkflow('upgrade-sla');

    this.checkOnInitPaymentStep(['address']);

    this.initialized = true;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  protected checkSelectedProduct(ifStatement: boolean) {
    return this.model.subscriptionSla?.index === this.model.selectedSla?.index
      || this.model.subscriptionSla?.index > this.model.selectedSla?.index
  }

  public onInvoiceAddressBack() {
    // Switch to workflow change cu
    this.router.navigate(['/do', 'change-sla', this.applianceId]);
  }

  public onPaymentMethodBack() {
    this.navigate(['address']);
  }

  public onBuy() {
    this.buyService.confirmUpgrade().subscribe(
      (saleOrder: any) => {
        this.navigate(['complete'])
      }
    );
  }
}
